import React from "react";
import "./IndustriesSection.css";

import {
  HeartPulse,
  ShoppingCart,
  GraduationCap,
  Truck,
  Building2,
  UtensilsCrossed,
  Cpu,
  CarFront,
} from "lucide-react";

const industries = [

  {
    icon: <HeartPulse size={34} />,
    title: "Healthcare",
    description:
      "AI-enabled healthcare systems, OCR workflows, patient dashboards and medical automation platforms.",
  },

  {
    icon: <ShoppingCart size={34} />,
    title: "Ecommerce",
    description:
      "Scalable ecommerce ecosystems with payment gateways, inventory systems and customer engagement platforms.",
  },

  {
    icon: <UtensilsCrossed size={34} />,
    title: "Food & Bakery",
    description:
      "Modern food ordering systems, bakery commerce platforms and customer-centric digital experiences.",
  },

  {
    icon: <Truck size={34} />,
    title: "Logistics",
    description:
      "Transportation dashboards, fleet monitoring systems and realtime business automation solutions.",
  },

  {
    icon: <Building2 size={34} />,
    title: "NGO Management",
    description:
      "Beneficiary management systems, QR attendance tracking and rehabilitation workflow platforms.",
  },

  {
    icon: <GraduationCap size={34} />,
    title: "Education",
    description:
      "Learning systems, educational dashboards and institution management platforms.",
  },

  {
    icon: <Cpu size={34} />,
    title: "Business Automation",
    description:
      "Enterprise dashboards, analytics systems and AI-powered operational automation workflows.",
  },

  {
    icon: <CarFront size={34} />,
    title: "Transportation",
    description:
      "Driver platforms, GPS systems, passenger monitoring and intelligent fare management systems.",
  },

];

const IndustriesSection = () => {

  return (

    <section className="industries-section">

      <div className="industries-container">

        {/* HEADER */}
        <div className="industries-header">

          <p className="industries-label">
            INDUSTRIES WE SERVE
          </p>

          <h2 className="industries-title">

            Software Solutions
            <br />

            Across Multiple Industries

          </h2>

          <p className="industries-description">

            We build scalable digital systems for
            healthcare, ecommerce, logistics,
            transportation, education and enterprise
            business automation.

          </p>

        </div>

        {/* GRID */}
        <div className="industries-grid">

          {industries.map((industry, index) => (

            <div
              className="industry-card"
              key={index}
            >

              <div className="industry-icon">

                {industry.icon}

              </div>

              <h3>
                {industry.title}
              </h3>

              <p>
                {industry.description}
              </p>

            </div>

          ))}

        </div>

      </div>

    </section>

  );

};

export default IndustriesSection;